import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from '../../_services/alert.service.';

@Component({
  selector: 'app-modals',
  templateUrl: './modals.component.html',
  styles: []
})
export class ModalsComponent implements OnInit, OnDestroy {

  constructor(private alert: AlertService) { }

  subs: Subscription[] = [];

  showAlert = false;
  showAlertCarrelloConfiguratore = false;

  alertMessage = '';

  ngOnInit() {
    this.subs = this.subs.concat([
      this.alert.apriAlert.subscribe(message => { this.showAlert = true; this.alertMessage = message; }),
      this.alert.apriAlertCarrelloConfiguratore.subscribe(message => { this.showAlertCarrelloConfiguratore = true; this.alertMessage = message; })
    ]);
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
